import { render } from "./ContattiSearchResult.vue?vue&type=template&id=d89ddf14&ts=true"
import script from "./ContattiSearchResult.vue?vue&type=script&lang=ts"
export * from "./ContattiSearchResult.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__